export class UrlConfigService {
  getQueryParam(param: string, defaultValue: string): string {
    const urlParams = new URLSearchParams(window.location.search);
    const configFilePath = urlParams.get(param);
    return configFilePath || defaultValue;
  }
}

export const configService = new UrlConfigService();
